'use client';

import type React from 'react';
import { AuthenticationErrorProvider } from '@clara/ui';

export default function ProvidersLayout({ children }: Readonly<{ children: React.ReactNode }>) {
  return <AuthenticationErrorProvider>{children}</AuthenticationErrorProvider>;
}
